import { useState } from "react";
import { Box, Button } from "@mui/material";
import { SiteUploadPopup } from "./site-upload-popup";
import { TutorialPopupUpload } from "../../tutorials/tutorial-popup-upload";
import { PROPERTY_SOURCE } from "../../../constants/site-settings.constants";
import { luckyorangeTrackEven } from "../../../services/lucky-orange/luckyorange-events";
import { useUserContext } from "../../../services/context/user-context";

// svg
import { ReactComponent as IconUpload } from "../../../assets/svg/upload-cloud.svg";
import { COLORS_GLOBAL } from "../../../constants/colors.constants";


export const SiteUpload = ({ updatePropertyData, propertyData, setUploading, deleteDrawing }) => {
  const { viewOnly } = useUserContext();
  const [openUploadPopup, setOpenUploadPopup] = useState(false);

  const uploadHandler = () => {
    luckyorangeTrackEven("Site Settings: open upload file popup");
    setOpenUploadPopup(true);
    setUploading(true);
    if(propertyData.propertySource === PROPERTY_SOURCE.FILE){
      updatePropertyData("uploadedPropertyPerimeter", propertyData.perimeter);
      updatePropertyData("uploadedFileName", propertyData.fileName);
      updatePropertyData("uploadedUnits", propertyData.units);
      updatePropertyData("uploadedPropertyArea", propertyData.propertyArea);
      updatePropertyData("uploadedPropertyGeoJSON", propertyData.propertyGeoJSON);
    }
  };

  const closeHandler = () => {
    setOpenUploadPopup(false);
    setUploading(false);
  }

/*   useEffect(()=>{
    if(deleteDrawing){
      setOpenUploadPopup(false);
    }
    
  }, [deleteDrawing]) */

  return (
    <>
      <SiteUploadPopup
        open={openUploadPopup}
        onClose={closeHandler}
        updatePropertyData={updatePropertyData}
        propertyData={propertyData}
        deleteDrawing={deleteDrawing}
      />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          mt: "6px",
        }}
      >
        <Button
          sx={{
            width: "100%",
            background: "#343745",
            color: "#fff",
            textTransform: "none",
            boxShadow: 2,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            ":disabled": {
              color: "#C7C7D6",
              background: "#EEEEF6",
            },
            ":hover": {
              boxShadow: 4,
            },
          }}
          onClick={uploadHandler}
          disabled={viewOnly}
        >
          <IconUpload stroke={viewOnly ? COLORS_GLOBAL.BTN_DISABLED : "#fff"} width="16px" height="16px" />
          Upload CAD file
        </Button>
        <TutorialPopupUpload display={propertyData.propertySource === PROPERTY_SOURCE.HAND_DRAWN} />
      </Box>
    </>
  );
};
